import './facility-overzicht.scss';

( function() {

	const CONFIG = window.junctionFacilityOverzicht || null;

	const SELECTORS = {
		root:        '[data-facility-overzicht]',
		filterList:  '[data-facility-filters]',
		filterItem:  '[data-facility-filter]',
		grid:        '[data-facility-grid]',
		loader:      '[data-facility-loader]',
		empty:       '[data-facility-empty]',
	};

	const CLASSES = {
		loading: 'is-loading',
		active:  'uk-active',
	};

	const MIN_LOADER_MS = 250;

	const initBlock = ( root ) => {
		if ( ! root || root.dataset.facilityOverzichtInit === '1' ) {
			return;
		}
		root.dataset.facilityOverzichtInit = '1';

		const filterList = root.querySelector( SELECTORS.filterList );
		const grid       = root.querySelector( SELECTORS.grid );
		if ( ! filterList || ! grid ) {
			return;
		}

		const empty      = root.querySelector( SELECTORS.empty );
		const parentId   = parseInt( root.dataset.facilityParent || '0', 10 );
		if ( ! parentId ) {
			return;
		}

		let currentFilter = '';
		let requestId     = 0;

		filterList.addEventListener( 'click', ( event ) => {

			const target = event.target.closest( SELECTORS.filterItem );
			if ( ! target || ! filterList.contains( target ) ) {
				return;
			}
			event.preventDefault();

			const slug = target.getAttribute( 'data-facility-filter' ) || '';
			if ( slug === currentFilter ) {
				return;
			}

			filterList.querySelectorAll( SELECTORS.filterItem ).forEach( ( el ) => {
				el.classList.remove( CLASSES.active );
			} );
			target.classList.add( CLASSES.active );

			currentFilter = slug;
			fetchAndRender( slug );
		} );

		const fetchAndRender = ( slug ) => {

			if ( ! CONFIG || ! CONFIG.ajaxUrl ) {
				return;
			}

			const id = ++requestId;
			root.classList.add( CLASSES.loading );
			if ( empty ) {
				empty.hidden = true;
			}

			const startedAt = Date.now();

			const body = new URLSearchParams();
			body.set( 'action', CONFIG.action );
			body.set( 'nonce', CONFIG.nonce );
			body.set( 'parent_id', String( parentId ) );
			body.set( 'filter', slug );

			fetch( CONFIG.ajaxUrl, {
				method:      'POST',
				credentials: 'same-origin',
				headers:     { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
				body:        body.toString(),
			} )
				.then( ( response ) => response.ok ? response.json() : Promise.reject( response ) )
				.then( ( payload ) => {
					if ( id !== requestId ) {
						return;
					}
					const data  = payload && payload.success && payload.data ? payload.data : null;
					const html  = data && typeof data.html === 'string' ? data.html : '';
					const count = data && typeof data.count === 'number' ? data.count : 0;

					const elapsed = Date.now() - startedAt;
					const delay   = Math.max( 0, MIN_LOADER_MS - elapsed );

					window.setTimeout( () => {
						if ( id !== requestId ) {
							return;
						}
						grid.innerHTML = html;
						if ( empty ) {
							empty.hidden = count > 0;
						}
						root.classList.remove( CLASSES.loading );
					}, delay );
				} )
				.catch( () => {
					if ( id !== requestId ) {
						return;
					}
					root.classList.remove( CLASSES.loading );
				} );
		};
	};

	const init = () => {
		document.querySelectorAll( SELECTORS.root ).forEach( initBlock );
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}

} )();
